// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "842") return "artifacts/842/5.348.0-b9b65fe-b9b65fe/index.js";
if (chunkId === "102") return "artifacts/102/5.348.0-b9b65fe-b9b65fe/index.js";
  // return url for filenames based on template
  return "chunks/" + chunkId + "." + "c3a1b9b7" + ".chunk.js"
}